import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import TwoInputModal from '../../common/TwoInputModal'

import * as Strings from './strings'
import * as configActions from '../../../actions/Config'
import * as userActions from '../../../actions/User'

class EditPasswordModal extends Component {
  state = {
    passwordInput: '',
    repeatPasswordInput: '',
    errorPassword: '',
    errorRepeatPassword: '',
    errorMessage: ''
  }

  componentWillReceiveProps(nextProps) {
    const { config, user } = this.props

    if (
      nextProps.config.showEditPasswordModal &&
      !config.showEditPasswordModal
    ) {
      this.setState({
        passwordInput: '',
        repeatPasswordInput: '',
        errorPassword: '',
        errorRepeatPassword: '',
        errorMessage: ''
      })
    }

    if (
      !nextProps.user.isUpdating &&
      nextProps.user.errorUpdating === null &&
      user.isUpdating
    ) {
      this.props.hideEditPasswordModal()
    } else if (
      !nextProps.user.isUpdating &&
      nextProps.user.errorUpdating !== null &&
      user.isUpdating
    ) {
      this.setState({
        errorMessage: Strings.default.INTERNAL_ERROR[config.language]
      })
    }
  }

  update() {
    const { user, config } = this.props
    const { passwordInput, repeatPasswordInput } = this.state

    this.setState({ errorMessage: '' })

    if (passwordInput !== repeatPasswordInput) {
      this.setState({
        errorPassword: Strings.default.PASSWORDS_DO_NOT_MATCH[config.language],
        errorRepeatPassword:
          Strings.default.PASSWORDS_DO_NOT_MATCH[config.language]
      })
    } else {
      if (passwordInput === '') {
        this.setState({
          errorPassword: Strings.default.MANDATORY_FIELD[config.language]
        })
      }

      if (repeatPasswordInput === '') {
        this.setState({
          errorRepeatPassword: Strings.default.MANDATORY_FIELD[config.language]
        })
      }
    }

    if (passwordInput !== '' && passwordInput === repeatPasswordInput) {
      const postData = { password: passwordInput }

      this.props.tryUpdateSelf(user.token, postData)
    }
  }

  render() {
    const { config, user } = this.props
    const {
      passwordInput,
      repeatPasswordInput,
      errorPassword,
      errorRepeatPassword,
      errorMessage
    } = this.state

    return (
      <TwoInputModal
        show={config.showEditPasswordModal}
        onHide={() => this.props.hideEditPasswordModal()}
        placeholders={[
          Strings.default.PASSWORD[config.language],
          Strings.default.REPEAT_PASSWORD[config.language]
        ]}
        inputs={[passwordInput, repeatPasswordInput]}
        onChange1={text =>
          this.setState({
            passwordInput: text,
            errorPassword: '',
            errorMessage: ''
          })
        }
        onChange2={text =>
          this.setState({
            repeatPasswordInput: text,
            errorRepeatPassword: '',
            errorMessage: ''
          })
        }
        errors={[errorPassword, errorRepeatPassword, errorMessage]}
        header={Strings.default.EDIT_PASSWORD[config.language]}
        onDone={() => this.update()}
        loading={user.isUpdating}
        language={config.language}
        secretInputs={[true, true]}
      />
    )
  }
}

function mapStateToProps({ config, data, user }) {
  return { config, data, user }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...configActions, ...userActions }, dispatch)
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditPasswordModal)



// WEBPACK FOOTER //
// ./src/components/containers/EditPasswordModal/index.js